import { i18n } from "@/plugins/i18n";


export default (field, other = []) => {
  return (state) => {
    const fitError = state.errors.find?.(error => error.startsWith(`${field}__`) || other.includes(error));
    return fitError && [i18n.t(`errors.${fitError}`)] || [];
  }
}